import { render } from "./SignInECC.vue?vue&type=template&id=46be3983"
import script from "./SignInECC.vue?vue&type=script&lang=ts"
export * from "./SignInECC.vue?vue&type=script&lang=ts"
script.render = render

export default script